import * as React from 'react';
import { AuthorEndpointResult } from '@/utils/functions/wordpress/fetchAuthor';
import Breadcrumb from '@/components/display/headers/Breadcrumb';
import Link from 'next/link';
import ImageWithFallback from '@core/components/display/images/ImageWithFallback';

type SitemapAuthorsPageLayoutProps = {
    authors: AuthorEndpointResult[];
};

const SitemapAuthorsPageLayout = (props: SitemapAuthorsPageLayoutProps) => {
    const { authors } = props;

    return (
        <main className="border-b xl:border-none w-full">
            <div className="p-12 border-b">
                <Breadcrumb
                    items={[
                        {
                            title: 'Site Map',
                            link: '/sitemap',
                        },
                        {
                            title: 'Authors',
                            link: '/sitemap/authors',
                        },
                    ]}
                />
                <div className="">
                    <h1 className="self-stretch w-full text-5xl font-semibold text-left text-[#110b29]">
                        Authors Index
                    </h1>
                    <p className="self-stretch w-full text-xl text-left text-gray-600"></p>
                </div>
            </div>
            <div className="p-12 grid gap-8 grid-cols-1 xs:grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-10">
                {authors.map(item => (
                    <div key={item.slug} className="flex flex-col justify-start items-start flex-grow gap-3 bg-white">
                        <Link href={`/author/${item.slug}`} passHref>
                            <a>
                                <div className="w-48 h-48 flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 bg-[#f8b4e4]">
                                    <ImageWithFallback
                                        alt={item.display_name}
                                        src={item.image_url}
                                        width={475}
                                        height={475}
                                        className="object-cover h-48"
                                    />
                                </div>
                                <div className="flex flex-col justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative">
                                    <p className="self-stretch flex-grow-0 flex-shrink-0 w-[193.33px] text-xl text-center text-[#110b29]">
                                        {item.display_name}
                                    </p>
                                </div>
                            </a>
                        </Link>
                    </div>
                ))}
            </div>
        </main>
    );
};

export default SitemapAuthorsPageLayout;
